import { z } from "zod";
import { terminalWorksites } from "../../../attendances";

export const patchTerminalPairingSchema = z.object({
	deviceId: z.string().nonempty(),
});

export type PatchTerminalPairingSchema = z.infer<typeof patchTerminalPairingSchema>;

/**
 * The worksite the owner binds a terminal to when they approve it. Every attendance the device
 * books lands on this worksite, which is why the enum is narrower than the attendance one.
 */
export const patchTerminalPairingBodySchema = z.object({
	worksite: z.enum(terminalWorksites),
});

export type PatchTerminalPairingBodySchema = z.infer<typeof patchTerminalPairingBodySchema>;
